module.exports = __webpack_public_path__ + "static/media/tabbing-effect-shape.c9de4541.svg";